"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFlattenObject = void 0;
const getFlattenObject = (obj, representative = '') => {
    let newObj = {};
    try {
        if (obj === undefined || obj === null)
            return;
        if (Array.isArray(obj) || typeof obj !== 'object')
            return { [representative]: obj };
        Object.entries(obj).forEach(([key, value]) => {
            const currKey = representative ? `${representative}.${key}` : key;
            newObj = { ...newObj, ...(0, exports.getFlattenObject)(value, currKey) };
        });
    }
    catch (err) {
        // eslint-disable-next-line no-console
        console.error('some error occured while flattening the object', err);
    }
    return newObj;
};
exports.getFlattenObject = getFlattenObject;
//# sourceMappingURL=objectHelper.js.map